import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();
  const nextLang = language === 'en' ? 'Swahili' : 'English';
  const label = language === 'en' ? 'EN' : 'SW';

  return (
    <button
      type="button"
      className="language-switcher"
      onClick={toggleLanguage}
      aria-label={`Switch to ${nextLang}`}
      title={`Switch to ${nextLang}`}
    >
      <span className="language-code">{label}</span>
    </button>
  );
};

export default LanguageSwitcher;
